export const TOOLTIP_STATES: any = {
  "APPROVED": 'Approved',
  "REVIEW": 'In Review',
  "REQUEST_ERROR": 'Rejected',
  "DRAFT": 'Not Started',
  "INCOMPLETE": 'In Progress',
  "COMING_SOON": 'Coming Soon'
}